import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import deleteFacetFilterFromSlug from '@modules/trials/search/facetFilters/deleteFacetFilterFromSlug'
import { usePathname } from 'next/navigation'
import { useState } from 'react'
import { useLocationFacetRefinement } from './Hooks/useLocationFacetRefinement'

export default function LocationFilterRefinementList({
  activeLocationLabel,
  inputClassName,
}: {
  activeLocationLabel?: string
  inputClassName?: string
}) {
  const [isFocused, setIsFocused] = useState(false)
  const pathname = usePathname()

  const {
    handlePredictionClick,
    navigateWithFilters,
    predictions,
    searchTerm,
    setSearchTerm,
    setSelectedLocation,
  } = useLocationFacetRefinement({
    initialLocation: activeLocationLabel,
  })

  return (
    <div className='relative size-full'>
      <input
        className={classMerge(
          'h-11 w-full rounded-lg border-[1.5px] border-grey200 focus:outline-none [&::-webkit-search-cancel-button]:hidden [&::-webkit-search-decoration]:hidden',
          searchTerm ? 'pl-2.5 pr-12 placeholder:text-black' : 'px-6',
          inputClassName,
        )}
        onBlur={(e) => {
          e.preventDefault()
          setIsFocused(false)
        }}
        onChange={(e) => setSearchTerm(e.target.value)}
        onFocus={() => setIsFocused(true)}
        placeholder='Type Location'
        type='search'
        value={searchTerm}
      />
      {searchTerm && (
        <button
          aria-label='Clear search term'
          className='absolute right-4 top-1/2 -translate-y-1/2 transform'
          onClick={() => {
            // Clear the search and selected location
            setSearchTerm('')
            setSelectedLocation(undefined)
            const url = deleteFacetFilterFromSlug({
              facet: 'city',
              slug: pathname,
            })
            navigateWithFilters(url)
          }}
          type='button'
        >
          <Icon icon={faXmark} />
        </button>
      )}
      <div
        className={classMerge(
          'z-50 -mt-1.5 w-full rounded-b-lg border-[1.5px] border-neutral200 bg-white p-6',
          isFocused && predictions.length > 0 ? 'absolute' : 'hidden',
        )}
      >
        <Text
          className='text-neutral400 antialiased'
          styleName='p-small-strong'
        >
          Suggestions
        </Text>
        <ul className='max-h-96 space-y-2 overflow-y-scroll'>
          {predictions.map((prediction) => (
            <li key={prediction.place_id}>
              <Text
                className='mt-6 w-full rounded text-left antialiased'
                onClick={() => {
                  handlePredictionClick(prediction)
                  trackEvent(
                    TrackingEvents.SEARCH_LANDER_LOCATION_FILTER_CLICKED,
                    {
                      val: prediction.description,
                    },
                  )
                }}
                onMouseDown={(e) => e.preventDefault()}
                styleName='p-small'
              >
                {prediction.description}
              </Text>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
